module.exports = __webpack_public_path__ + "img/cookie.6c589d5d.png";